<div class="bundle-offer-prompt" *ngIf="view">
  <h1 class="prompt-title">{{ "bundleOfferPrompt.title" | translate }}</h1>

  <div class="offer-image" *ngIf="imageUrl; else noImage">
    <img [src]="imageUrl" alt="" (error)="imageUrl = null" />
  </div>
  <ng-template #noImage>
    <div class="offer-placeholder" aria-hidden="true">
      <img
        *ngIf="group && iconImage && !demo; else fallbackIcon"
        src="https://images.deliverymanager.gr/{{ group }}/appicon/{{ iconImage }}"
        alt=""
      />
      <ng-template #fallbackIcon>
        <ion-icon name="cart-outline"></ion-icon>
      </ng-template>
    </div>
  </ng-template>

  <div class="offer-info">
    <h2 class="offer-name">{{ view.offerProduct.name }}</h2>
    <p class="offer-price">{{ view.offerTotal | priceWithComma: view.showPricesWithComma }}{{ view.currencySymbol }}</p>
  </div>

  <div class="actions">
    <ion-button
      class="view-offer"
      expand="block"
      [disabled]="answered"
      (click)="accept()"
    >
      {{ "bundleOfferPrompt.viewOffer" | translate }}
    </ion-button>
    <ion-button
      class="dismiss-offer"
      fill="clear"
      expand="block"
      [disabled]="answered"
      (click)="decline()"
    >
      {{ "bundleOfferPrompt.noThanks" | translate }}
    </ion-button>
  </div>
</div>
